import { createClient } from '@supabase/supabase-js';

// Create a dedicated Supabase client for the OG_Enterprise project
const enterpriseSupabaseUrl = (import.meta.env.VITE_OG_ENTERPRISE_URL || '').trim();
const enterpriseSupabaseAnonKey = (import.meta.env.VITE_OG_ENTERPRISE_ANON_KEY || '').trim();

if (!enterpriseSupabaseUrl || !enterpriseSupabaseAnonKey) {
  console.error('CRITICAL: OG_Enterprise Supabase environment variables are not set.');
  // In a production app, you might want to throw an error here or show a fallback UI
}

const enterpriseSupabase = createClient(enterpriseSupabaseUrl, enterpriseSupabaseAnonKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false
  }
});

export const careersService = {
  /**
   * Get all active job postings from the Enterprise database
   */
  async getActiveJobs() {
    try {
      const { data, error } = await enterpriseSupabase
        .from('job_postings')
        .select('*')
        .eq('status', 'active')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data;
    } catch (err) {
      console.error('Error fetching jobs from enterprise DB:', err);
      throw err;
    }
  },

  /**
   * Get global visibility setting
   */
  async getGlobalVisibility() {
    try {
      const { data, error } = await enterpriseSupabase
        .from('careers_settings')
        .select('value')
        .eq('key', 'global_visibility')
        .single();
      
      if (error) return true; // Default to true if error
      return data?.value?.enabled ?? true;
    } catch (err) {
      return true;
    }
  },

  /**
   * Submit a job application to the Enterprise database
   */
  async submitApplication(applicationData) {
    try {
      const { data, error } = await enterpriseSupabase
        .from('job_applications')
        .insert(applicationData)
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (err) {
      console.error('Error submitting application to enterprise DB:', err);
      throw err;
    }
  }
};